import { wrapTranslationsSchema } from '../../helpers/i18n/wrapTranslationsSchema';

export const ProductsTranslations = wrapTranslationsSchema({
	name: 'ProductsTranslations',
	title: 'Products Translations',
	sanityId: 'products',
	fields: {
		variants: 'Variants',
		fulfillmentTime: 'Estimated Fulfillment Time',
		consumptionModel: 'Your organization may be charged for this',
		viewDetails: 'View Details',
		productDetailsPanelDescription: 'Descriptions',
		productDetailsPanelVariants: 'Available options',
		productDetailsPanelRelated: 'You may also like',
		productDetailsPanelViewInStores: 'View in stores',
	},
});
